module.exports = __webpack_public_path__ + "static/media/twenty-four-seven.eb3f03ef.svg";